<script>
import {
  VIRTUAL_CURRENCY_STATUS,
  DIALOG_TITLE_TYPE,
  getValue
} from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";
import {
  getBankAccountList,
  createBankAccount,
  updateBankAccount,
  getSupportRegion
} from "@/api/tradingCenter";

export default {
  computed: {
    VIRTUAL_CURRENCY_STATUS() {
      return VIRTUAL_CURRENCY_STATUS;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    formatApiDate() {
      return formatApiDate;
    },
    getValue() {
      return getValue;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        status: "",
        page: 1,
        limit: 10
      },
      dialogFormVisible: false, // 新增 or 编辑的弹框
      dialogType: "",
      rules: {
        region: [
          { required: true, message: "地区不能为空", trigger: "change" }
        ],
        bankName: [
          { required: true, message: "银行名称不能为空", trigger: "change" }
        ],
        bankUserName: [
          { required: true, message: "开户名称不能为空", trigger: "change" }
        ],
        bankAccount: [
          { required: true, message: "银行卡号不能为空", trigger: "change" }
        ],
        bankBranch: [
          { required: true, message: "开户支行不能为空", trigger: "change" }
        ]
      },
      form: {
        id: 0,
        region: "", // 地区
        bankName: "", // 银行名称
        bankUserName: "", // 开户名称
        bankAccount: "", // 银行卡号
        bankBranch: "" // 开户支行
      },
      btnLoading: false,
      regionOption: []
    };
  },
  created() {
    this.getList();
    this.getRegionOption();
  },
  watch: {},
  mounted() {},
  methods: {
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      getBankAccountList(this.listQuery)
        .then(response => {
          this.list = (response.data && response.data.data) || [];
          this.total = response.data.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    // 查询地区选项
    getRegionOption() {
      getSupportRegion().then(resp => {
        console.log("resp", resp);
        if (resp && resp.code === 0) {
          this.regionOption = resp.data;
        }
      });
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     */
    checkDialogFormVisible(status, editObj = {}) {
      if (editObj && Object.keys(editObj).length !== 0) {
        this.form.id = editObj.id;
        this.form.region = editObj.region;
        this.form.bankName = editObj.bank_name;
        this.form.bankUserName = editObj.bank_username;
        this.form.bankAccount = editObj.bank_account;
        this.form.bankBranch = editObj.bank_branch;
      }
      this.dialogFormVisible = status;
      if (!status) {
        this.form.id = 0;
        this.form.region = "";
        this.form.bankName = "";
        this.form.bankUserName = "";
        this.form.bankAccount = "";
        this.form.bankBranch = "";
        this.$refs.form.resetFields();
      }
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const params = this.form;
          this.btnLoading = true;
          createBankAccount(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },

    /**
     * 状态切换
     * @param scope
     */
    statusChange(scope) {
      const params = {
        id: scope.id,
        status: scope.status === 0 ? 1 : 0
      };
      updateBankAccount(params).then(() => {
        this.getList();
        this.$notify({
          title: "成功",
          message: "状态编辑成功",
          type: "success",
          duration: 2000
        });
      });
    }
  }
};
</script>

<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 200px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in VIRTUAL_CURRENCY_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {})"
        >新增</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="id" label="编号" width="80"> </el-table-column>
      <el-table-column prop="region" label="地区"> </el-table-column>
      <el-table-column prop="bank_name" label="银行名称"> </el-table-column>
      <el-table-column prop="bank_username" label="开户名称">
      </el-table-column>
      <el-table-column prop="bank_account" label="银行卡号"> </el-table-column>
      <el-table-column prop="bank_branch" label="开户支行"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ getValue(VIRTUAL_CURRENCY_STATUS, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.created_at) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="修改时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.updated_at) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="checkDialogFormVisible(true, scope.row)"
            style="margin-right: 8px"
            >编辑</el-button
          >
          <el-popconfirm
            confirm-button-text="好的"
            cancel-button-text="不用了"
            icon="el-icon-info"
            icon-color="red"
            title="确定要修改状态吗？"
            @confirm="statusChange(scope.row)"
          >
            <el-switch
              :value="scope.row.status === 0"
              slot="reference"
            ></el-switch>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="checkDialogFormVisible(false, {})"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="地区" prop="region">
          <el-select
            v-model="form.region"
            placeholder="请选择"
            style="width: 200px"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in regionOption"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="银行名称" prop="bankName">
          <el-input v-model="form.bankName" placeholder="请输入" />
        </el-form-item>

        <el-form-item label="开户名称" prop="bankUserName">
          <el-input v-model="form.bankUserName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="银行卡号" prop="bankAccount">
          <el-input v-model="form.bankAccount" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="开户支行" prop="bankBranch">
          <el-input v-model="form.bankBranch" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {})">取消</el-button>
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>
